export default __webpack_public_path__ + "static/media/step_1.350fdea9.jpg";